// extracted by mini-css-extract-plugin
export default {"scrollBlock":"Scrollbars-module__scrollBlock___7st32"};